import React from 'react';
import { Box } from '@mui/material';
import MobileHeaderTop from './MobileHeaderTop';
import MobileUrlInput from '../Video/MobileUrlInput';
import DesktopProfileMenu from '../Auth/DesktopProfileMenu';
import ProfileManageModal from '../Auth/ProfileManageModal';
import LogoutDialog from '../Auth/LogoutDialog';

const MobileHeader = ({
  // Props from parent
  url,
  videoTitle,
  loading,
  isLoggedIn,
  userEmail,
  userPhoto,
  user,
  hideLoginButton,
  // State from hooks
  t,
  isAnalyzePage,
  logoutDialogOpen,
  setLogoutDialogOpen,
  profileAnchorEl,
  profilePopoverOpen,
  profileManageModalOpen,
  // Handlers from hooks
  handleDrawerToggle,
  handleLogoClick,
  handleUrlChange,
  handleClearTitle,
  handleAnalyzeClick,
  handleLoginClick,
  handleProfileClick,
  handleProfileClose,
  handleProfileLogout,
  handleLogoutConfirm,
  handleProfileManage,
  handleProfileManageClose,
  handleProfileSave,
  handlePasswordChange,
  handleAccountDelete
}) => {
  return (
    <Box sx={{ 
      bgcolor: '#fff', 
      borderBottom: '1px solid #eee', 
      width: '100%', 
      zIndex: 1400, 
      position: 'fixed', 
      top: 0,
      left: 0,
      paddingTop: 'env(safe-area-inset-top, 0px)'
    }}>
      {/* 상단: 햄버거-로고-로그아웃 한 줄 */}
      <MobileHeaderTop
        onDrawerToggle={handleDrawerToggle}
        onLogoClick={handleLogoClick}
        onProfileMenuOpen={handleProfileClick}
        onLogin={handleLoginClick}
        user={{ displayName: userEmail, email: userEmail, photo: userPhoto }}
        t={t}
        isLoggedIn={isLoggedIn}
        hideLoginButton={hideLoginButton}
        showMenuButton={true}  // analyze페이지에서는 항상 햄버거 버튼 표시
      />

      {/* 하단: URL 입력 영역 (분석 페이지가 아닐 때만) */}
      {!isAnalyzePage && (
        <MobileUrlInput
          url={url}
          onUrlChange={handleUrlChange}
          videoTitle={videoTitle}
          onTitleClear={handleClearTitle}
          onAnalyzeClick={handleAnalyzeClick}
          isAnalyzePage={isAnalyzePage}
          isProcessing={loading}
          t={t}
        />
      )}

      {/* 프로필 팝오버 */}
      <DesktopProfileMenu
        anchorEl={profileAnchorEl}
        open={profilePopoverOpen}
        onClose={handleProfileClose}
        onLogout={handleProfileLogout}
        onProfileManage={handleProfileManage}
        userEmail={userEmail}
        t={t}
      />

      {/* 로그아웃 다이얼로그 */}
      <LogoutDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleLogoutConfirm}
        t={t}
      />

      {/* 프로필 관리 모달 */}
      <ProfileManageModal
        open={profileManageModalOpen}
        onClose={handleProfileManageClose}
        user={user}
        userEmail={userEmail}
        onSave={handleProfileSave}
        onPasswordChange={handlePasswordChange}
        onAccountDelete={handleAccountDelete}
      />
    </Box>
  );
};

export default MobileHeader; 